<template>
  <div style="width: 100%; height: 100%; overflow: hidden; position: relative">
    <!-- <img
      style="width: 100%; height: 100%"
      src="~@/assets/images/intro-bg.png"
    /> -->
    <div class="intro-text">
      <img src="~@/assets/images/intro-text.png" />
    </div>
    <div class="intro-container">
      <div class="top">
        <swiper
          class="intro-swiper"
          :modules="modules"
          :autoplay="{
            delay: 3000,
          }"
          effect="fade"
          :fade-effect="{ crossFade: true }"
          :pagination="{
            clickable: true,
            bulletClass: 'intro-pagination-class',
            bulletActiveClass: 'intro-pagination-active-class',
          }"
          :loop="true"
          style="height: 100%; width: 100%"
          @slideChange="onSlideChange"
        >
          <swiper-slide>
            <div class="top-pic-main">
              <img
                class="back-img"
                src="~@/assets/images/intro-pic-1-back.png"
              />
              <img
                class="front-img1"
                src="~@/assets/images/intro-pic-1-front.png"
              />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="top-pic-main">
              <img
                class="back-img"
                src="~@/assets/images/intro-pic-2-back.png"
              />
              <img
                class="front-img2"
                src="~@/assets/images/intro-pic-2-front.png"
              />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="top-pic-main">
              <img
                class="back-img"
                src="~@/assets/images/intro-pic-3-back.png"
              />
              <img
                class="front-img3"
                src="~@/assets/images/intro-pic-3-front.png"
              />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="top-pic-main">
              <img
                class="back-img"
                src="~@/assets/images/intro-pic-4-back.png"
              />
              <img
                class="front-img4"
                src="~@/assets/images/intro-pic-4-front.png"
              />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="top-pic-main">
              <img
                class="back-img"
                src="~@/assets/images/intro-pic-5-back.png"
              />
              <img
                class="front-img5"
                src="~@/assets/images/intro-pic-5-front.png"
              />
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="bottom">
        <div class="title-video">
          <div>
            <div class="title">{{ currentItem.title }}</div>
            <div class="sub-title">{{ currentItem.sub_title }}</div>
          </div>
          <img
            v-if="currentItem.video_url"
            src="~@/assets/images/intro-video.png"
            @touchstart="videoTouch(currentItem.video_url)"
          />
        </div>
        <div class="desc" :class="{'swiper-no-swiping': [2,3,4].includes(currentItem.index)}" v-html="currentItem.description"></div>
        <ul class="btn-list">
          <li v-for="(item, index) in currentItem.btnList" :key="index">
            <template v-if="item.isCode">
              <img :src="item.icon" @touchstart.stop="codeTouch" />
              <div class="code-bg" v-show="isShowCode" @touchstart.stop>
                <img :src="item.code" />
              </div>
            </template>
            <template v-else>
              <a :href="item.url" target="_blank">
                <img :src="item.icon" />
              </a>
            </template>
          </li>
        </ul>
      </div>
      <div class="intro-page">
        <ul :style="{transform: `translateY(${-7.963 * currentIndex}rem)`}" >
          <li>01</li>
          <li>02</li>
          <li>03</li>
          <li>04</li>
          <li>05</li>
        </ul>
        <div class="total">
          <span>/</span>
          <span>05</span>
        </div>
      </div>
    </div>
  </div>
  <videoDialog ref="videoDialogRef"></videoDialog>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from "vue";

import { loadHomePage,loadGamePage } from "@/assets/js/preload";

import videoDialog from "../videoDialog.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectFade,
  Autoplay,
} from "swiper/modules";
const modules = [Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay];

const videoDialogRef = ref();
const videoTouch = (video_url) => {
  videoDialogRef.value?.show(video_url);
};

const currentIndex = ref(0);
const onSlideChange = (e) => {
  console.log(e.realIndex);
  currentIndex.value = e.realIndex;
};

const isShowCode = ref(false);
const codeTouch = (e) => {
  isShowCode.value = !isShowCode.value;
};
onMounted(() => {
  // loadHomePage()
  // loadGamePage()
  document.addEventListener("touchstart", (e) => {
    isShowCode.value = false;
  });
});

import iconComment from "@/assets/images/intro-btn-comment.png";
import iconDy from "@/assets/images/intro-btn-dy.png";
import iconGift from "@/assets/images/intro-btn-gift.png";
import iconHome from "@/assets/images/intro-btn-home.png";
import iconQiandao from "@/assets/images/intro-btn-qiandao.png";
import iconTap from "@/assets/images/intro-btn-tap.png";
import iconWx from "@/assets/images/intro-btn-wx.png";

import code_jlsy from "@/assets/images/intro-code-jlsy.jpg";
import code_xlwy from "@/assets/images/intro-code-xlwy.jpg";
import code_shdl from "@/assets/images/intro-code-shdl.jpg";
import code_shyyl from "@/assets/images/intro-code-shyyl.jpg";

const currentItem = computed(() => {
  return list[currentIndex.value];
});
const list = reactive([
  {
    index:0,
    title: "九灵神域",
    sub_title: "JIULINGSHENYU",
    video_url: "",

    description: ` 
    <p>乐牛游戏全新修仙玄幻仙侠MMO手游。</p>   
    <p>
      修仙之路千奇百遇，仙君修真结盟问道，仙侣作伴再续情缘，宠物武神助战，激爽连招战斗，助力仙君战力暴涨，缔造神域传说！
    </p>`,
    btnList: [
      {
        icon: iconHome,
        url: "http://jlsy.leniu.com/",
      },
      {
        icon: iconWx,
        isCode: true,
        code: code_jlsy,
      },
      {
        icon: iconDy,
        url: "https://v.douyin.com/i6WPPndX/",
      },
      {
        icon: iconTap,
        url: "https://www.taptap.cn/app/192892",
      },
    ],
  },
  {
    index:1,
    title: "驯龙物语",
    sub_title: "XUNLONGWUYU",
    video_url: "",

    description: ` 
    <p>乐牛游戏首款治愈系轻策略回合制手游。</p>   
    <p>
      作为“守护者”的你应召前守护大陆，邂逅冒险伙伴，育成可爱萌宠，和小伙伴一起共战七罪暗王，展开一场奇幻异世界冒险之旅！
    </p>`,
    btnList: [
      {
        icon: iconHome,
        url: "https://xlwy.leniu.com/",
      },
      {
        icon: iconWx,
        isCode: true,
        code: code_xlwy,
      },
      {
        icon: iconDy,
        url: "https://v.douyin.com/i6WP7rev/",
      },
      {
        icon: iconTap,
        url: "https://www.taptap.cn/app/167942",
      },
    ],
  },
  {
    index:2,
    title: "神火大陆",
    sub_title: "SHENHUODALU",
    video_url: "https://player.youku.com/embed/XNTkzMzg0NzU1Mg==",

    description: ` 
    <p>乐牛游戏全新北欧魔幻MMO手游。</p>   
    <p>
      全景再现北欧文化和时代风貌，带您探索无数神话背后的秘密与冲突，重现北欧民族崇尚“牺牲与抗争”的民族风格。
    </p>`,
    btnList: [
      {
        icon: iconHome,
        url: "https://shdl.leniu.com/",
      },
      {
        icon: iconWx,
        isCode: true,
        code: code_shdl,
      },
      {
        icon: iconDy,
        url: "https://v.douyin.com/i6WPPbJt/",
      },
      {
        icon: iconTap,
        url: "https://www.taptap.cn/app/241181",
      },
    ],
  },
  {
    index:3,
    title: "山海与妖灵",
    sub_title: "SHANHAIYUYAOLING",
    video_url: "https://shyyl.leniu.com/img/video2.mp4",

    description: ` 
    <p>乐牛游戏首款精致唯美国风手游。</p>   
    <p>
      三神四皇，十二祖巫，游戏内所有设计均源于神话故事《山海经》，致力于给你一场惊险刺激的异世修行之旅。
    </p>`,
    btnList: [
      {
        icon: iconHome,
        url: "https://shyyl.leniu.com/",
      },
      {
        icon: iconWx,
        isCode: true,
        code: code_shyyl,
      },
      {
        icon: iconDy,
        url: "https://v.douyin.com/i6WPWTEf/",
      },
      {
        icon: iconTap,
        url: "https://www.taptap.cn/app/444908",
      },
    ],
  },
  {
    index:4,
    title: "积分商城",
    sub_title: "JIFENSHANGCHENG",
    video_url: "",

    description: ` 
    <p>乐牛游戏旗下官方周边商城。</p>   
    <p>集合了游戏礼包，主题周边，购物卡等惊喜福利！</p>   
    <p>定期上新主题礼包，赶紧来看看吧！</p>   
    `,
    btnList: [
      {
        icon: iconHome,
        url: "http://ucenter.leniu.com/#/prodList?origin=1",
      },
      {
        icon: iconQiandao,
        url: "http://ucenter.leniu.com/#/sign",
      },
      {
        icon: iconGift,
        url: "http://libao.leniu.com/mobile",
      },
      {
        icon: iconComment,
        url: "http://ucenter.leniu.com/#/prodComment",
      },
    ],
  },
]);
</script>

<style lang="scss" scoped>
.intro-text {
  position: absolute;
  top: 13.6111rem;
  left: 0;
  right: 0;
  text-align: center;

  img {
    width: 92.5rem;
    height: 8.0556rem;
  }
}
.intro-container {
  position: absolute;
  top: 24.7222rem;
  left: 0;
  right: 0;
  margin: auto;
  width: 94.8148rem;
  height: 138.5185rem;
  background-color: #fff;
  box-shadow: 0 0 1rem rgba(61, 66, 77, 0.2);
  border-radius: 4rem;

  display: flex;
  flex-direction: column;

  .top {
    height: 76.6667rem;
    width: 100%;
    flex-shrink: 0;
    box-sizing: border-box;
    background-color: rgba(61, 66, 77, 0.2);

    border-top-left-radius: 3rem;
    border-top-right-radius: 3rem;

    .top-pic-main {
      position: relative;
      width: 100%;
      height: 100%;
      opacity: 1;
      transition: all 0.6s;

      .back-img {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .front-img1 {
        position: absolute;
        bottom: 0;
        left: -2.7778rem;
        width: 100rem;
        height: 111.9444rem;
      }
      .front-img2 {
        position: absolute;
        bottom: 0;
        left: -2rem;
        width: 99.1667rem;
        height: 99.1667rem;
      }
      .front-img3 {
        position: absolute;
        bottom: 0;
        left: -2.7778rem;
        width: 100rem;
        height: 100rem;
      }
      .front-img4 {
        position: absolute;
        bottom: 0;
        left: -2.7778rem;
        width: 99.9074rem;
        height: 96.4815rem;
      }
      .front-img5 {
        position: absolute;
        bottom: 0;
        left: -2.7778rem;
        width: 99.6296rem;
        height: 96.3889rem;
      }
    }
  }
  .bottom {
    // height: 61.9444rem;
    flex: 1;
    width: 100%;
    padding: 0 5.1852rem;
    box-sizing: border-box;

    .title-video {
      width: 100%;
      margin-top: 6.6667rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      .title {
        font-size: 7.7778rem;
        font-family: "SourceHanSansCN", "Microsoft YaHei", "Arial Narrow", Arial,
          sans-serif;
        color: #090909;
      }
      .sub-title {
        font-size: 2.5926rem;
        color: #cdcdcd;
        letter-spacing: 1.1111rem;
      }
      img {
        width: 19.1667rem;
        height: 9.1667rem;
      }
    }
    .desc {
      margin-top: 4.8148rem;
      font-size: 2.7778rem;
      color: #090909;
      height: 12.7778rem;
      overflow: auto;
    }
    .btn-list {
      margin-top: 4.8148rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 2.5926rem;
      height: 11.1111rem;
      li {
        position: relative;
        width: 11.0185rem;
        height: 11.0185rem;
        img {
          width: 100%;
          height: 100%;
        }
        .code-bg {
          position: absolute;
          top: -23rem;
          width: 17.3148rem;
          height: 18.3333rem;
          left: 50%;
          transform: translateX(-50%);
          padding: 1.3rem;
          background: url(~@/assets/images/code-bg.png) center / cover no-repeat;
          background-color: #fff;
        }
      }
    }
  }
  .intro-page {
    position: absolute;
    right: 1rem;
    bottom: -9rem;
    color: #4e8cae;
    display: flex;
    font-weight: 700;
    height: 7.963rem;
    overflow: hidden;

    ul {
      font-size: 6.8148rem;
      transition: transform 0.36s;
      li {
        height: 7.963rem;
      }
    }
    .total {
      height: 6.963rem;
      display: flex;
      align-items: flex-end;
      :first-child {
        font-size: 4rem;
        margin: 0 .5rem;
        // vertical-align: bottom;
      }
      :last-child {
        font-size: 4rem;
        // vertical-align: bottom;
      }
    }
  }
}
</style>
<style>
.intro-swiper {
  overflow: visible;
}
.intro-swiper .swiper-pagination {
  height: 6.4815rem;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.intro-pagination-class {
  height: 2.6852rem;
  width: 2.6852rem;
  background: url(~@/assets/images/intro-swiper-1.png) no-repeat center;
  background-size: cover;
  margin: 0 2.2222rem;
}

.intro-pagination-active-class {
  height: 4.0741rem;
  width: 4.0741rem;
  background: url(~@/assets/images/intro-swiper-2.png) no-repeat center;
  background-size: cover;
  margin: 0 2.2222rem;
}
.intro-swiper .swiper-slide {
  transition-duration:1.6s !important
}
.intro-swiper .swiper-slide .top-pic-main {
  opacity: 0;
}
.intro-swiper .swiper-slide-active .top-pic-main {
  opacity: 1;
}
</style>